import React, { useState, memo, useMemo } from 'react';
import '../../App.css';
import copy from 'copy-to-clipboard'
import toast, { Toaster } from 'react-hot-toast';
import { API_URL, FEATURES } from '../../config';
import marked from "marked";
import ToolSettings from '../audio/ToolSettings';
import { sendLinkToApp as sendToApp } from '../../utils/nativeBridge';

const ChatMessage = memo(({ message, msgId, isUser, isError, answers, tool, isLast, onSubmit, isComplete, isSubmitted, noSubmitButton }) => {
  const hasMessageContent = typeof message === 'string' && message.length > 0;
  const isToolReply = Boolean(tool);
  const shouldShowSubmitButton = FEATURES.showFeedback && isComplete && !noSubmitButton && !isToolReply;
  const shouldRenderBotSection = !isError && !isUser && (hasMessageContent || shouldShowSubmitButton);

  const handleIssueClick = () => {
    if (onSubmit) onSubmit(msgId);
  };
  const [adjustAnswer, setAdjustAnswer] = useState(answers === undefined || answers === null ? '' : answers.referAnswer);
  const [adjustQuestion, setAdjustQuestion] = useState(answers === undefined || answers === null ? '' : answers.referQuestion);
  const [adjustTool, setAdjustTool] = useState(tool === undefined || tool === null ? null : tool);
  const [isAnswerEdit, setAnswerEdit] = useState(true)
  const [isQuestionEdit, setQuestionEdit] = useState(true)
  const [textColorAnswer, setTextColorAnswer] = useState('gray')
  const [textColorQuestion, setTextColorQuestion] = useState("gray")
  const onAnswerEdit = () => {
    setAnswerEdit(false)
    setTextColorAnswer('black')
  }

  const onQuestionEdit = () => {
    setQuestionEdit(false)
    setTextColorQuestion('black')
  }

  const [btnStyle, setBtnStyle] = useState({
    width: '100px',
    height: '30px',
    marginLeft: '20px',
    borderRadius: '8px',
  });


  //点赞
  const [isLikeEnable, setIsLikeEnable] = useState(true);
  const [likeSrc, setLikeSrc] = useState(require('../../assets/icons/like.svg').default)
  //
  const [isDisLikeEnable, setIsDisLikeEnable] = useState(true);
  const [disLikeSrc, setDisLikeSrc] = useState(require('../../assets/icons/dislike.svg').default)

  let [isShowSrc, setIsShowSrc] = useState(false)

  //是否展示配置回答
  let [isEditReply, setEditReply] = useState(true)

  const handleAnswerInputChange = (e) => {
    setAdjustAnswer(e.target.value);
  };
  const handleQuestionInputChange = (e) => {
    setAdjustQuestion(e.target.value);
  };

  const htmlContent = useMemo(() => {
    if (!message) return "";
    // console.log("Rendering ChatMessage, original message:", message);
    const cleanMarkdown = compressBlankLines(message);
    return marked(cleanMarkdown);
  }, [message]);
  //点赞
  const onLike = () => {

    setIsDisLikeEnable(true)
    setDisLikeSrc(require('../../assets/icons/dislike.svg').default)
    if (answers === undefined) {
    } else {
      handleLikePost(answers, 1)
    }

    setIsLikeEnable(false);
    setLikeSrc(require('../../assets/icons/like_click.svg').default)
  }
  function isEmptyString(str) {
    if (str === "" || /^\s*$/.test(str)) {
      return true;
    } else {
      return false;
    }
  }


  const onAdjustAnswer = () => {
    if (isEmptyString(adjustAnswer) || isEmptyString(adjustQuestion)) {
      toast("问题或回答不能为空")
      return
    }
    let strData = {
      referID: answers.referID,
      newQuestion: adjustQuestion,
      newAnswer: adjustAnswer
    };

    let httpRequest = new XMLHttpRequest();

    httpRequest.open('POST', `${API_URL}/modifyQuestionAnswer`, true);
    httpRequest.setRequestHeader("Accept", "application/json");
    httpRequest.setRequestHeader("Content-type", "application/json");

    let json = JSON.stringify(strData)
    httpRequest.send(json);

    httpRequest.onload = function () {//
      let json = httpRequest.responseText;
      console.log(json)
      let obj = JSON.parse(decodeURIComponent(json));
      if (obj.success) {
        toast("修改成功")
      } else {
        toast("修改失败")
      }
    };
  }


  const onUnLike = () => {
    setIsLikeEnable(true);
    setLikeSrc(require('../../assets/icons/like.svg').default)
    console.log("answer: " + answers)
    if (answers === undefined) {
      console.log("answer 没有定义")
    } else {
      handleLikePost(answers, 2)
    }
    setIsDisLikeEnable(false)
    setDisLikeSrc(require('../../assets/icons/dislike_click.svg').default)
  }
  //点赞接口
  const handleLikePost = async (answers, feedback) => {
    var id = answers.referId
    let strData = {
      id: id,
      feedback: feedback
    };
    let httpRequest = new XMLHttpRequest();
    httpRequest.open('POST', `${API_URL}/document/like`, true);
    httpRequest.setRequestHeader("Accept", "application/json");
    httpRequest.setRequestHeader("Content-type", "application/json");
    let json = JSON.stringify(strData)
    httpRequest.send(json);

    httpRequest.onload = function () {//
      if (httpRequest.readyState === 4 && httpRequest.status === 200) {
        let json = httpRequest.responseText;
        console.log(json)
      }
    };
  }

  //复制
  const copybt = (param) => () => {
    copy(param)
    toast("Copied successfully")
  }

  const showSrc = () => {
    if (isShowSrc) {
      setIsShowSrc(false)
      isShowSrc = false
    } else {
      setIsShowSrc(true)
      isShowSrc = true
    }
  }

  const showEditReplay = () => {
    if (isEditReply) {
      isEditReply = false;
      setEditReply(false)
    } else {
      isEditReply = true
      setEditReply(true)
    }
  }

  function compressBlankLines(markdown) {
    if (markdown === undefined || markdown === null) {
      return "";
    }
    //console.log("Original markdown:", markdown);
    return markdown;//.replace(/\n\s*\n\s*/g, '\n');
  }

  function handleMDClick(e) {
    const anchor = e.target.closest('a');
    if (anchor) {
      e.preventDefault();
      sendToApp(anchor.href);
    }
  }


  return (
    <div>
      {shouldRenderBotSection &&
        <div className='container-left'>
          <label className='AIHeadLabel'>
          </label>
          <div className='chat-message-bot-container'>
            {hasMessageContent && (
              <div className='chat-message-bot'
                dangerouslySetInnerHTML={{ __html: htmlContent }}
                onClick={handleMDClick}
              >
              </div>
            )}
            {shouldShowSubmitButton && (
              <button className={`submit-issue-button ${isSubmitted ? 'submitted' : ''}`} onClick={handleIssueClick} disabled={isSubmitted}>
                Still Not Working
                <img src={require('../../assets/icons/submit.svg').default} alt="arrow" className="submit-issue-icon" />
              </button>
            )}
          </div>
        </div>
      }

      {!isError && isUser &&
        <div className='container-right'>
          <div className='chat-message-user'>
            {message}
          </div>
          <label className='UserHeadLabel'>
          </label>
        </div>
      }

      {!isUser && false &&
        <div className={'chat-message-container'}>
          <div className={'chat-message-container-img'}>
            <img className={'chat-message-img'} src={likeSrc}
              alt='img'
              onClick={onLike}
              title={"like"}
              tabIndex={isLikeEnable ? -1 : 0}
            >
            </img>

            <img className={'chat-message-img'}
              src={disLikeSrc}
              alt='es-lint'
              title={'disagree'}
              onClick={onUnLike}
              tabIndex={isDisLikeEnable ? -1 : 0}
            >
            </img>

            <img className={'chat-message-img'}
              src={require('../../assets/icons/copy.svg').default}
              alt='es-lint'
              title={'Copy'}
              onClick={copybt(message)}>
            </img>
            <Toaster />

          </div>
        </div>
      }

      {
        isShowSrc && !isUser && !isEditReply &&
        <div className={'chat-message-adjust'}>

          <button
            onClick={showEditReplay}>
            Adjust answer
          </button>
        </div>
      }

      {isError &&
        <div className='chat-message-user-error'>
          {message}
        </div>
      }

      {tool &&
        <div>
          <div className='tool-settings-wrap'>
            <ToolSettings
            strategy={tool.strategy}
            leftOrRight={tool.earSide}
            strengthValue={tool.value}
            isHistory={false}  //这里控制是否显示下面的按钮
            isLast={isLast}
            msgId={msgId}
            />
          </div>
          <div className="line-placeholder"></div>
        </div>
      }

    </div>


  );
});

export default ChatMessage;
